import { useEffect, useState } from 'react'
import { useAppSelector } from '@/app/hooks'
import { selectUser } from '@/features/auth/authSlice'
import { ROLE_RENTER } from '@/types/auth'
import { getDashboardSystemAnnouncementBanner } from '@/features/system-announcement'
import { normalizeAnnouncementDescriptionHtml } from '@/features/system-announcement/utils/normalizeAnnouncementHtml'

/**
 * Angular `DashboardComponent.loadSystemAnnouncement`:
 * GET `/api/system_announcement` for non-renter roles (org-configured HTML banner).
 */
export function useDashboardSystemAnnouncement() {
  const user = useAppSelector(selectUser)
  const roleName = user?.current_role?.role_name ?? ''
  const [html, setHtml] = useState<string>('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!roleName || roleName === ROLE_RENTER) {
      setHtml('')
      setLoading(false)
      return
    }

    let cancelled = false
    setLoading(true)

    void getDashboardSystemAnnouncementBanner()
      .then((raw) => {
        if (cancelled) return
        const trimmed = (raw ?? '').trim()
        setHtml(trimmed ? normalizeAnnouncementDescriptionHtml(trimmed) : '')
      })
      .catch(() => {
        if (!cancelled) setHtml('')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [roleName])

  return { html, loading }
}
